import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import { getWrapperClasses, getWrapperStyles } from './styles';

export default function Save({ attributes }) {
  const blockProps = useBlockProps.save({
    className: getWrapperClasses(attributes),
    style: getWrapperStyles(attributes),
  });

  const innerBlocksProps = useInnerBlocksProps.save(blockProps);

  return <ul {...innerBlocksProps} />;
}
